// extracted by mini-css-extract-plugin
export default {"loaderContainer":"MainLoader_loaderContainer__XiiSL","suspense":"MainLoader_suspense__Hez1s"};